// src/pages/ConfirmacionPago.js
import React, { useEffect, useState } from 'react';
import { Box, Card, Typography, Avatar, Button, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from "./api"; 
import { api as apiUser } from "../api";



const ConfirmacionPago = () => {
  const navigate = useNavigate();
    const { internalId } = useParams();
  const [pago, setPago] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);

useEffect(() => {
  const loginAndFetch = async () => {
    try {
      const data = await apiUser.usuario.getUsuarioByInternalId(internalId);
      setUser(data.user);
      localStorage.setItem("user", JSON.stringify(data.user));
      localStorage.setItem("token", data.token);
      const res = await api.pagos.getPagoByInternalId(internalId); 
      setPago(res);
    } catch (err) {
        console.error("Error detallado: ", err);
      setError("Error al traer los datos de pago o usuario");
    } finally {
      setLoading(false);
    }
  };

  loginAndFetch();
}, [internalId]);


  if (loading) return <p>Cargando...</p>;
  if (error) return <p>{error}</p>;

  return (
    <Box p={2} maxWidth={600} mx="auto" textAlign="center">
      <Card sx={{ p: 4, borderRadius: 3, boxShadow: 4, mb: 4 }}>
        <Avatar sx={{ bgcolor: 'success.main', mx: 'auto', mb: 2, width: 60, height: 60 }}>
          <CheckCircleIcon sx={{ fontSize: 40 }} />
        </Avatar>
        <Typography variant="h5" fontWeight="bold" mb={1}>
         {pago.message}
        </Typography>
        <Typography variant="subtitle1" mb={3}>
          ¡Gracias <strong>{user.nombre}</strong>! Tu pago por <strong>${pago.data.amount}</strong> se ha procesado correctamente.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/dashboard')}
          sx={{ mt: 2 }}
        >
          Volver al Inicio
        </Button>
      </Card>
    </Box>
  );
};

export default ConfirmacionPago;
